const usersListColumns = () => {
  return [
    {
      text: "id",
      dataField: "user_id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.user_id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      formatter: (cellContent, item) => (
        <>{item?.email ? item?.name : `Visitor ${item?.guest_id}`}</>
      ),
    },
    {
      text: "Email",
      dataField: "email",
      formatter: (cellContent, item) => <>{item.email}</>,
    },
    {
      text: "Views",
      dataField: "total_views",
      formatter: (cellContent, item) => <>{item.total_views}</>,
    },
  ]
}

export default usersListColumns
